import type { LatLng } from '@bilmat/shared';

type Props = {
  location: LatLng;
  open: boolean;
  onClose: () => void;
};

export function NavActionSheet({ location, open, onClose }: Props) {
  if (!open) return null;
  const { lat, lng } = location;
  // URL-format följer prototypens openNav (references/prototype.html).
  const links: Array<{ label: string; href: string }> = [
    {
      label: 'Google Maps',
      href: `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`,
    },
    { label: 'Apple Maps', href: `maps://maps.apple.com/?daddr=${lat},${lng}&dirflg=d` },
    { label: 'Waze', href: `waze://?ll=${lat},${lng}&navigate=yes` },
  ];
  return (
    <div className="action-sheet-backdrop" onClick={onClose}>
      <div
        className="action-sheet"
        role="dialog"
        aria-label="Navigera hit"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="action-sheet-group">
          {links.map((l) => (
            <a
              key={l.label}
              className="action-sheet-row"
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {l.label}
            </a>
          ))}
        </div>
        <button type="button" className="action-sheet-cancel" onClick={onClose}>
          Avbryt
        </button>
      </div>
    </div>
  );
}
